import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import SubNavPopover from "./SubNavPopover";
import utils from "../../../utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import CONSTANTS from "../../../constants";

function UrlDrivenTopNav({
  apppath = null,
  fields = null,
  sendNavItemToShow,
  item = null,
  activeTab = null,
  subUrlVal = null,
  subItems = null,
  tenantSettings = null,
  path = null,
  passedNav = null,
}) {
  const [activePopover, setActivePopover] = useState(null);
  const [navToShow, setNavToShow] = useState(null);
  const [navItems, setNavItems] = useState(passedNav !== null ? passedNav : []);
  const [appName, setAppName] = useState();

  const { getAccessTokenSilently, user } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    let parts = path ? path.split("/") : null;
    let app = parts && parts.length > 0 ? parts[1] : null;
    if (app === "apps") {
      const urlParts = location.pathname.split("/");
      const customctalink = urlParts[2];
      app = customctalink ? `dynamic/${customctalink}` : null;
    } else {
      app =
        app && CONSTANTS.APPS_ALT_TITLE[app]
          ? CONSTANTS.APPS_ALT_TITLE[app]
          : app;
    }
    setAppName(app);
  }, [path, location.pathname]);

  const togglePopover = (nav, popoverId) => {
    setActivePopover((prev) => (prev === popoverId ? null : popoverId));
  };

  const getAppNavItems = async (
    endpoint,
    app,
    token,
    apiKey,
    isProd = false
  ) => {
    let params = `?app_key=${app}&token=${token}&is_prod=${isProd}`;
    const response = await utils.getData(endpoint, apiKey, params);
    return response;
  };

  useEffect(() => {
    try {
      (async () => {
        if (appName && passedNav === null) {
          // sometimes we need to get the data from the parent to prevent re-fetching
          const accessToken = await utils.getAccessToken(
            getAccessTokenSilently,
            user
          );

          let apiKey = await utils.getAPIKey(accessToken);
          const appNavItems = await getAppNavItems(
            "get_app_blueprint_b2c",
            appName,
            accessToken.accessToken,
            apiKey,
            false
          );
          setNavItems(appNavItems);
        }
      })();
    } catch (error) {
      console.error("Error fetching token or user:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appName]);

  useEffect(() => {
    if (passedNav !== null) {
      setNavItems(passedNav);
    }
  }, [passedNav]);

  useEffect(() => {
    if (apppath && tenantSettings) {
      let pathToDisplay = utils.findURLPath(
        tenantSettings &&
          tenantSettings.tenant &&
          tenantSettings.tenant.fields &&
          tenantSettings.tenant.fields.apps
          ? tenantSettings.tenant.fields.apps
          : "",
        apppath,
        false
      );
      setNavToShow(pathToDisplay);
    }
  }, [apppath, tenantSettings]);

  const closePopover = () => {
    setActivePopover(null);
  };

  if (item && subItems) {
    let theSubURLVal;
    if (subUrlVal) {
      theSubURLVal = subUrlVal;
    } else {
      theSubURLVal = item.fields.slug;
    }
    apppath = `${navToShow ? navToShow : apppath}/${theSubURLVal}`;
  }

  const hasSingleVisibleNav =
    navItems &&
    navItems.appFields &&
    navItems.appFields.length === 1 &&
    navItems.appFields[0] &&
    navItems.appFields[0].show;

  const shouldHideTopNav =
    hasSingleVisibleNav &&
    navItems.appFields[0] &&
    (!Array.isArray(navItems.appFields[0].subNav) ||
      navItems.appFields[0].subNav.length <= 1);

  return (
    <div className="url-driven-topnav border-bottom-light m-b-end-08 p-i">
      {apppath &&
      navItems &&
      navItems.appFields &&
      navItems.appFields.length > 0 &&
      !shouldHideTopNav
        ? hasSingleVisibleNav
          ? // Handle single navigation item - top level only
            // If there is only one tab with subnavs it will show the navs as single items across the tab structure
            navItems.appFields[0].subNav.map((navItem, index) => {
              let basePath;
              if (navToShow) {
                basePath =
                  !navToShow.includes(subUrlVal) && subUrlVal
                    ? `${navToShow}/${subUrlVal}`
                    : navToShow;
              } else {
                basePath = subUrlVal
                  ? apppath.includes(subUrlVal)
                    ? apppath
                    : `${apppath}/${subUrlVal}`
                  : apppath; // prevent /null in path if subUrlVal is null
              }

              const finalPath = `/${basePath}/${navItem.urlForField}`;

              const isTabActive =
                navItem.subNav?.some(
                  (sub) => sub.urlForField === activeTab?.url
                ) ||
                (activeTab?.level_three &&
                  navItem.groupingTitle === "Capability Analysis");
              const showAsActive = activePopover === null && isTabActive;

              return (
                <LinkContainer to={finalPath} key={index}>
                  <Button
                    variant="none"
                    className={`tab-nav-btn blueprint-nav-1 ${
                      showAsActive ? "active-tab" : ""
                    }`}
                    onClick={() => sendNavItemToShow(apppath, null)}
                  >
                    {navItem.linkLabel}
                  </Button>
                </LinkContainer>
              );
            })
          : // If there are multiple tabs with or without subnavs it goes into the SubNavPopover component
            navItems.appFields.map((navItem, index) => {
              // Only show as active if we are actually on a Summary or Company page for that group
              const isTabActive =
                activeTab?.title === navItem.groupingTitle ||
                (activeTab?.level_three &&
                  navItem.groupingTitle === "Capability Analysis");

              // Do NOT show as active just because dropdown is open
              const showAsActive = isTabActive;
              const isDropdownOpen = activePopover === index;

              if (navItem.show === true) {
                return (
                  <SubNavPopover
                    key={index}
                    activeTab={activeTab}
                    isActive={isDropdownOpen}
                    showAsActive={showAsActive}
                    togglePopover={(nav) => togglePopover(nav, index)}
                    closePopover={closePopover}
                    sendNavItemToShow={sendNavItemToShow}
                    navList={navItem}
                    apppath={apppath}
                    navItem={navItem.groupingTitle}
                    navLevelThree={
                      fields?.fields?.capabilityAnalysesbyCompany || null
                    }
                  />
                );
              } else {
                return null;
              }
            })
        : null}
    </div>
  );
}

export default UrlDrivenTopNav;
